import React, { type FC } from 'react';

export const CreatingTemplate: FC = () => {
    const createTemplateImage = new URL('./create-template.png', import.meta.url).toString();

    return (
        <div className="text-white flex flex-col gap-4 pb-2">
            <p className="text-2xl">Creating a template</p>
            <p>
                Click “Create a Template” and upload SVG files for your designs. Upload a separate SVG file for each
                style or size variant you want to add to your template.
            </p>
            <img src={createTemplateImage} alt="create-template" />
            <p>
                Next, create Text and Image fields by selecting text or image layers in each frame, and assigning them
                to a new or existing field.
            </p>
        </div>
    );
};
